import { Component, OnInit, HostBinding } from '@angular/core';
import { AppSettings } from '../app.settings';

@Component({
  selector: 'app-testimonial',
  template: `
    <div class="col">
      <div class="w-100 testimonial primary-color text-center">
        <span class="testimonial-body">{{ body }}</span>
        <span class="testimonial-source">{{ source }}</span>
      </div>
    </div>
  `
})
export class TestimonialComponent {
  body: string;
  source: string;
  @HostBinding('class.col') col = true;
  constructor(private settings: AppSettings) {
    const testimonials = this.settings.getValue('properties').testimonials;
    if (testimonials && testimonials.cash) {
      const selected =
        testimonials.cash[Math.floor(Math.random() * testimonials.cash.length)];
      this.body = selected[1];
      this.source = selected[0];
    }
  }
}
